import AddScenicItems from './AddScenicItems'
import SearchAndAdd from './SearchAndAdd'
import UnavailableScenicRoomItems from './UnavailableScenicRoomItems'

AddScenicItems.SearchAndAdd = SearchAndAdd
AddScenicItems.UnavailableScenicRoomItems = UnavailableScenicRoomItems

export default AddScenicItems
